import ravenIcon from '../assets/raven.svg'
import { googleFaviconUrl } from './favicons'

export interface Icon {
  library: string;
  name?: string;
  style?: string;
  strokeWidth?: number;
  src?: any;
}

export const ICONS: {[key: string]: Icon} = {
  home: { library: 'hero', name: 'HomeIcon', style: 'solid' },
  chevron_right: { library: 'hero', name: 'ChevronRightIcon', style: 'outline' },
  chevron_double_left: { library: 'hero', name: 'ChevronDoubleLeftIcon', style: 'outline' },
  chevron_double_right: { library: 'hero', name: 'ChevronDoubleRightIcon', style: 'outline' },
  plus: { library: 'hero', name: 'PlusIcon', style: 'outline' },
  account: { library: 'hero', name: 'BuildingOfficeIcon', style: 'solid' },
  account_outline: { library: 'hero', name: 'BuildingOfficeIcon', style: 'outline' },
  customer_list: { library: 'hero', name: 'BuildingOffice2Icon', style: 'outline' },
  activity: { library: 'lucide', name: 'Activity', strokeWidth: 2.5 },
  reachout: { library: 'hero', name: 'PaperAirplaneIcon', style: 'solid' },
  task: { library: 'hero', name: 'CheckIcon', style: 'solid' },
  followup: { library: 'hero', name: 'CalendarDaysIcon', style: 'solid' },
  crm_update: { library: 'hero', name: 'CloudIcon', style: 'solid' },
  salesforce_offline: { library: 'lucide', name: 'Feather', strokeWidth: 1.5 },
  leadiq_offline: { library: 'hero', name: 'CircleStackIcon', style: 'solid' },
  signal: { library: 'hero', name: 'BoltIcon', style: 'solid' },
  story: { library: 'hero', name: 'BookOpenIcon', style: 'solid' },
  agent: { library: 'hero', name: 'UserCircleIcon', style: 'outline' },
  audience: { library: 'hero', name: 'AdjustmentsHorizontalIcon', style: 'solid' },
  trigger: { library: 'hero', name: 'PlayIcon', style: 'solid' },
  sales_play: { library: 'hero', name: 'RocketLaunchIcon', style: 'solid' },
  chat_agent: { library: 'hero', name: 'ChatBubbleLeftEllipsisIcon', style: 'solid' },
  new_chat: { library: 'hero', name: 'PlusCircleIcon', style: 'outline' },
  chat_history: { library: 'hero', name: 'ListBulletIcon', style: 'outline' },
  buying_team: { library: 'hero', name: 'UsersIcon', style: 'solid' },
  contact: { library: 'hero', name: 'UserIcon', style: 'solid' },
  contact_outline: { library: 'hero', name: 'UserIcon', style: 'outline' },
  opportunity: { library: 'hero', name: 'BriefcaseIcon', style: 'solid' },
  pipeline_value: { library: 'hero', name: 'BanknotesIcon', style: 'solid' },
  timeline: { library: 'hero', name: 'ClockIcon', style: 'solid' },
  lifecycle: { library: 'hero', name: 'ArrowPathIcon', style: 'solid' },
  'arrow-right-circle': { library: 'hero', name: 'ArrowRightCircleIcon', style: 'solid' },
  arrow_right: { library: 'hero', name: 'ArrowRightIcon', style: 'outline' },
  arrow_left: { library: 'hero', name: 'ArrowLeftIcon', style: 'outline' },
  checkmark: { library: 'hero', name: 'CheckIcon', style: 'solid' },
  lock: { library: 'hero', name: 'LockClosedIcon', style: 'outline' },
  footprints: { library: 'lucide', name: 'Footprints', strokeWidth: 2 },
  wait: { library: 'hero', name: 'ClockIcon', style: 'outline' },
  manual: { library: 'hero', name: 'HandRaisedIcon', style: 'outline' },
  email: { library: 'hero', name: 'EnvelopeIcon', style: 'solid' },
  email_outline: { library: 'hero', name: 'EnvelopeIcon', style: 'outline' },
  salesforce_email: { library: 'hero', name: 'EnvelopeIcon', style: 'solid' },
  calendar: { library: 'hero', name: 'CalendarDaysIcon', style: 'solid' },
  note: { library: 'hero', name: 'DocumentTextIcon', style: 'solid' },
  salesforce_event: { library: 'hero', name: 'CalendarDaysIcon', style: 'solid' },
  salesforce_campaign_member: { library: 'hero', name: 'MegaphoneIcon', style: 'solid' },
  integration: { library: 'lucide', name: 'Plug2', strokeWidth: 2 },
  email_setting: { library: 'hero', name: 'Cog6ToothIcon', style: 'solid' },
  settings_gear: { library: 'hero', name: 'Cog6ToothIcon', style: 'outline' },
  unsubscribe: { library: 'hero', name: 'BellSlashIcon', style: 'solid' },
  agent_guardrail: { library: 'hero', name: 'ShieldCheckIcon', style: 'solid' },
  about: { library: 'hero', name: 'InformationCircleIcon', style: 'solid' },
  error: { library: 'hero', name: 'ExclamationCircleIcon', style: 'solid' },
  pipeline: { library: 'hero', name: 'FunnelIcon', style: 'solid' },
  filter: { library: 'hero', name: 'FunnelIcon', style: 'outline' },
  sort: { library: 'hero', name: 'ArrowsUpDownIcon', style: 'outline' },
  monitoring: { library: 'hero', name: 'ChartBarIcon', style: 'solid' },
  usage: { library: 'lucide', name: 'ChartLine', strokeWidth: 2 },
  user: { library: 'hero', name: 'UserCircleIcon', style: 'outline' },
  sequence: { library: 'hero', name: 'SquaresPlusIcon', style: 'outline' },
  action: { library: 'hero', name: 'PlayIcon', style: 'solid' },
  phone_call: { library: 'hero', name: 'PhoneIcon', style: 'solid' },
  phone_off: { library: 'lucide', name: 'PhoneOff', strokeWidth: 2 },
  keypad: { library: 'lucide', name: 'Grid3x3', strokeWidth: 2 },
  play: { library: 'hero', name: 'PlayIcon', style: 'solid' },
  voicemail: { library: 'lucide', name: 'Voicemail', strokeWidth: 2 },
  voicemail_outline: { library: 'lucide', name: 'Voicemail', strokeWidth: 1.5 },
  eye: { library: 'lucide', name: 'Eye', strokeWidth: 2 },
  eye_off: { library: 'lucide', name: 'EyeOff', strokeWidth: 2 },
  list: { library: 'lucide', name: 'List', strokeWidth: 2 },
  browser_window: { library: 'lucide', name: 'AppWindow', strokeWidth: 2 },
  linkedin: { library: 'lucide', name: 'Linkedin', strokeWidth: 2 },
  microphone: { library: 'hero', name: 'MicrophoneIcon', style: 'outline' },
  paperclip: { library: 'hero', name: 'PaperClipIcon', style: 'outline' },
  arrow_up: { library: 'hero', name: 'ArrowUpIcon', style: 'solid' },
  arrow_down: { library: 'hero', name: 'ArrowDownIcon', style: 'solid' },
  minus: { library: 'hero', name: 'MinusIcon', style: 'solid' },
  columns: { library: 'lucide', name: 'Columns2', strokeWidth: 1.5 },
  dark_mode: { library: 'hero', name: 'MoonIcon', style: 'solid' },
  logout: { library: 'hero', name: 'ArrowRightOnRectangleIcon', style: 'solid' },
  raven: { library: 'image', src: ravenIcon },
  salesforce: { library: 'image', src: googleFaviconUrl('salesforce.com', { size: 32 }) },
  leadiq: { library: 'image', src: googleFaviconUrl('leadiq.com', { size: 32 }) },
  pipedrive: { library: 'image', src: googleFaviconUrl('pipedrive.com', { size: 32 }) },
  hubspot: { library: 'image', src: googleFaviconUrl('hubspot.com', { size: 32 }) },
  gong: { library: 'image', src: googleFaviconUrl('gong.io', { size: 32 }) },
  openai: { library: 'image', src: googleFaviconUrl('openai.com', { size: 32 }) },
  anthropic: { library: 'image', src: googleFaviconUrl('claude.ai', { size: 32 }) },
  exa: { library: 'image', src: googleFaviconUrl('exa.ai', { size: 32 }) },
  outreach: { library: 'image', src: googleFaviconUrl('outreach.io', { size: 32 }) },
  warmly: { library: 'image', src: googleFaviconUrl('warmly.ai', { size: 32 }) },
  download: { library: 'hero', name: 'ArrowDownTrayIcon', style: 'outline' },
  upload: { library: 'hero', name: 'ArrowUpTrayIcon', style: 'outline' },
  close: { library: 'hero', name: 'XMarkIcon', style: 'outline' },
  check_circle: { library: 'hero', name: 'CheckCircleIcon', style: 'solid' },
  chevron_left: { library: 'hero', name: 'ChevronLeftIcon', style: 'outline' },
  chevron_down: { library: 'hero', name: 'ChevronDownIcon', style: 'outline' },
  chevron_up: { library: 'hero', name: 'ChevronUpIcon', style: 'outline' },
  arrow_path: { library: 'hero', name: 'ArrowPathIcon', style: 'outline' },
  external_link: { library: 'hero', name: 'ArrowTopRightOnSquareIcon', style: 'outline' },
  arrow_up_right: { library: 'hero', name: 'ArrowUpRightIcon', style: 'outline' },
  edit: { library: 'hero', name: 'PencilSquareIcon', style: 'outline' },
  pencil: { library: 'hero', name: 'PencilIcon', style: 'outline' },
  trash: { library: 'hero', name: 'TrashIcon', style: 'outline' },
  star: { library: 'hero', name: 'StarIcon', style: 'outline' },
  star_filled: { library: 'hero', name: 'StarIcon', style: 'solid' },
  stop: { library: 'hero', name: 'StopIcon', style: 'solid' },
  cancel_requested: { library: 'hero', name: 'StopIcon', style: 'solid' },
  salesforce_field_text: { library: 'lucide', name: 'Type', strokeWidth: 1.5 },
  salesforce_field_textarea: { library: 'lucide', name: 'AlignLeft', strokeWidth: 1.5 },
  salesforce_field_picklist: { library: 'lucide', name: 'List', strokeWidth: 1.5 },
  salesforce_field_boolean: { library: 'lucide', name: 'SquareCheck', strokeWidth: 1.5 },
  salesforce_field_date: { library: 'lucide', name: 'Calendar', strokeWidth: 1.5 },
  salesforce_field_email: { library: 'lucide', name: 'Mail', strokeWidth: 1.5 },
  salesforce_field_phone: { library: 'lucide', name: 'Phone', strokeWidth: 1.5 },
  salesforce_field_url: { library: 'lucide', name: 'Link', strokeWidth: 1.5 },
  salesforce_field_currency: { library: 'lucide', name: 'DollarSign', strokeWidth: 1.5 },
  salesforce_field_percent: { library: 'lucide', name: 'Percent', strokeWidth: 1.5 },
  salesforce_field_integer: { library: 'lucide', name: 'Hash', strokeWidth: 1.5 },
  salesforce_field_reference: { library: 'lucide', name: 'Search', strokeWidth: 1.5 },
  salesforce_field_address: { library: 'lucide', name: 'MapPin', strokeWidth: 1.5 },
  departure: {library: 'lucide', name: 'LogOut', strokeWidth: 1.5 },
  arrival: {library: 'lucide', name: 'LogIn', strokeWidth: 1.5 },
  add_contact: { library: 'lucide', name: 'UserPlus', strokeWidth: 2 },
  engaged: { library: 'hero', name: 'UserPlusIcon', style: 'solid' },
  add_company: { library: 'lucide', name: 'HousePlus', strokeWidth: 2 },
  import_csv: { library: 'lucide', name: 'FileUp', strokeWidth: 2 },
}

const SALESFORCE_FIELD_TYPE_TO_ICON_KEY: Record<string, string> = {
  string: 'salesforce_field_text',
  textarea: 'salesforce_field_textarea',
  picklist: 'salesforce_field_picklist',
  multipicklist: 'salesforce_field_picklist',
  boolean: 'salesforce_field_boolean',
  checkbox: 'salesforce_field_boolean',
  date: 'salesforce_field_date',
  datetime: 'salesforce_field_date',
  email: 'salesforce_field_email',
  phone: 'salesforce_field_phone',
  url: 'salesforce_field_url',
  currency: 'salesforce_field_currency',
  double: 'salesforce_field_percent',
  percent: 'salesforce_field_percent',
  number: 'salesforce_field_integer',
  int: 'salesforce_field_integer',
  integer: 'salesforce_field_integer',
  reference: 'salesforce_field_reference',
  lookup: 'salesforce_field_reference',
  address: 'salesforce_field_address',
}

export function getSalesforceFieldIconKey(fieldType: any): string {
  const wanted = String(fieldType || '').trim().toLowerCase()
  if (!wanted) return null
  return SALESFORCE_FIELD_TYPE_TO_ICON_KEY[wanted] || null
}

/**
 * Generic field-type → icon key resolver for any CRM.
 * Maps HubSpot, Pipedrive, and Salesforce type names to the shared icon set.
 */
const _GENERIC_FIELD_TYPE_TO_ICON: Record<string, string> = {
  // Salesforce (passthrough to existing map)
  ...SALESFORCE_FIELD_TYPE_TO_ICON_KEY,
  // HubSpot types
  enumeration: 'salesforce_field_picklist',
  bool: 'salesforce_field_boolean',
  phone_number: 'salesforce_field_phone',
  // Pipedrive types
  varchar: 'salesforce_field_text',
  text: 'salesforce_field_textarea',
  int: 'salesforce_field_integer',
  double: 'salesforce_field_percent',
  monetary: 'salesforce_field_currency',
  set: 'salesforce_field_picklist',
  enum: 'salesforce_field_picklist',
  user: 'salesforce_field_reference',
  org: 'salesforce_field_reference',
  people: 'salesforce_field_reference',
  time: 'salesforce_field_date',
  timerange: 'salesforce_field_date',
  daterange: 'salesforce_field_date',
}

export function getFieldIconKey(fieldType: any): string | null {
  const wanted = String(fieldType || '').trim().toLowerCase()
  if (!wanted) return null
  return _GENERIC_FIELD_TYPE_TO_ICON[wanted] || null
}

export function getIcon(key: string): Icon {
  const wanted = String(key || '').trim()
  const icon = (wanted ? ICONS[wanted] : null) || { library: 'hero', name: 'QuestionMarkCircleIcon', style: 'solid' }
  return {
    library: icon.library,
    name: icon.name || null,
    style: icon.style || null,
    strokeWidth: icon.strokeWidth || null,
    src: icon.src || null,
  }
}
